import { Add16 } from 'ui/icons/action/Add16';
import { Edit16 } from 'ui/icons/action/Edit16';
import { AddTagContainer, IconTagWrapper, InlineTooltipContent, TagWrapper } from '../Tags.styles';
import { Tag, TagProps } from '../Tag';
import { Popover, PopoverContent, PopoverTrigger } from 'ui/popover';

export const AddTag = (props: Pick<TagProps, 'size' | 'onClick'>) => (
  <Tag noBoxShadow hasInteraction isClickable data-test="add-tag-button" {...props}>
    <AddTagContainer>
      <Add16 height={12} width={12} />
      Add Label
    </AddTagContainer>
  </Tag>
);

export const EditTag = ({ size, ...rest }: Pick<TagProps, 'size' | 'onClick'>) => (
  <TagWrapper
    data-is-clickable
    data-has-box-shadow
    data-support-interaction
    data-size={size}
    data-test="edit-tags-button"
    {...rest}
  >
    <IconTagWrapper>
      <Edit16 />
    </IconTagWrapper>
  </TagWrapper>
);

export const RemainderTag = ({
  tags = [],
  ...rest
}: Pick<TagProps, 'size'> & { tags: string[] }) => (
  <Popover>
    <PopoverTrigger asChild={false}>
      <Tag noBoxShadow hasInteraction isClickable data-test="remainder-tag" {...rest}>
        <Add16 height={8} width={8} />
        {tags.length}
      </Tag>
    </PopoverTrigger>

    <PopoverContent side="bottom">
      <InlineTooltipContent>
        {tags.map((tag) => (
          <Tag text={tag} key={tag} {...rest} />
        ))}
      </InlineTooltipContent>
    </PopoverContent>
  </Popover>
);
